import { ActionTypes } from "../constants";

const reduceAttendances = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_TMS_EVENT_BOOKING_LIST_SUCCESS:
            return action.data;
        default:
            return state;
    }
};


export default reduceAttendances;
